import * as zod from 'zod';

import { HardwareConfigEquipmentMapping } from '@sb/ai/types';

import { Conditional } from '../../types';

export default zod.object({
  gpuTaskRunnerId: zod.string(),
  modelPath: zod.string(),
  timeout: zod.number(),
  isBimanual: zod.boolean(),
  isPrimary: zod.boolean(),
  equipmentKeyToEquipmentId: zod.record(zod.string()).default({}),
  hardwareConfigEquipmentMapping: HardwareConfigEquipmentMapping.default({}),
  condition: Conditional.nullable(),
  useLearnedCompletion: zod.boolean().default(false),
  learnedCompletionThreshold: zod.number().default(0.75),
  learnedCompletionConsecutiveCount: zod.number().int().default(2),
  useLearnedFailure: zod.boolean().default(false),
  learnedFailureThreshold: zod.number().default(0.75),
  learnedFailureConsecutiveCount: zod.number().int().default(2),
  useGripperMask: zod.boolean().default(true),
});
